import _classCallCheck from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _assertThisInitialized from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _getPrototypeOf from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import PropTypes from 'prop-types';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import merge from 'lodash/merge';
import noop from 'lodash/noop';
import omit from 'lodash/omit';
import set from 'lodash/set';
import BaseForm, { __childContextTypes, __childContextTypesBuild } from './BaseForm';

var childContextTypes = __childContextTypesBuild(merge({
  state: {
    validating: PropTypes.bool.isRequired
  }
}, __childContextTypes));

var Validated = function Validated(parent) {
  var _ =
  /*#__PURE__*/
  function (_parent) {
    _inherits(_, _parent);

    function _() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, _);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(_)).call.apply(_getPrototypeOf2, [this].concat(args))); // @ts-ignore

      _this.state = Object.assign(Object.assign({}, _this.state), {
        error: null,
        validate: false,
        validating: false,
        validator: _this.getChildContextSchema().getValidator(_this.props.validator)
      });
      _this.onValidate = _this.validate = _this.onValidate.bind(_assertThisInitialized(_this));
      _this.onValidateModel = _this.validateModel = _this.onValidateModel.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(_, [{
      key: "getChildContextError",
      value: function getChildContextError() {
        return _get(_getPrototypeOf(_.prototype), "getChildContextError", this).call(this) || this.state.error;
      }
    }, {
      key: "getChildContextState",
      value: function getChildContextState() {
        return Object.assign(Object.assign({}, _get(_getPrototypeOf(_.prototype), "getChildContextState", this).call(this)), {
          validating: this.state.validating
        });
      }
    }, {
      key: "getNativeFormProps",
      value: function getNativeFormProps() {
        return omit(_get(_getPrototypeOf(_.prototype), "getNativeFormProps", this).call(this), ['onValidate', 'validate', 'validator']);
      }
    }, {
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(_ref) {
        var _this2 = this;

        var model = _ref.model,
            schema = _ref.schema,
            validate = _ref.validate,
            validator = _ref.validator;

        // @ts-ignore
        _get(_getPrototypeOf(_.prototype), "componentWillReceiveProps", this).apply(this, arguments);

        if (this.props.schema !== schema || this.props.validator !== validator) {
          this.setState(function (state) {
            return {
              validator: state.bridge.getValidator(validator)
            };
          }, function () {
            if (shouldRevalidate(validate, _this2.state.validate)) {
              _this2.onValidate().catch(noop);
            }
          });
        } else if (!isEqual(this.props.model, model) && shouldRevalidate(validate, this.state.validate)) {
          this.onValidateModel(model).catch(noop);
        }
      }
    }, {
      key: "onChange",
      value: function onChange(key, value) {
        if (shouldRevalidate(this.props.validate, this.state.validate)) {
          this.onValidate(key, value).catch(noop);
        } // FIXME: https://github.com/vazco/uniforms/issues/293
        // if (this.props.validate === 'onSubmit' && this.state.validate) {
        //     this.setState(() => ({error: null}));
        // }
        // @ts-ignore


        _get(_getPrototypeOf(_.prototype), "onChange", this).apply(this, arguments);
      }
    }, {
      key: "__reset",
      value: function __reset(state) {
        return Object.assign(Object.assign({}, _get(_getPrototypeOf(_.prototype), "__reset", this).call(this, state)), {
          error: null,
          validate: false,
          validating: false
        });
      }
    }, {
      key: "onSubmit",
      value: function onSubmit(event) {
        var _this3 = this;

        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }

        var promise = new Promise(function (resolve, reject) {
          _this3.setState(function () {
            return {
              submitting: true,
              validate: true
            };
          }, function () {
            _this3.onValidate().then(function () {
              _get(_getPrototypeOf(_.prototype), "onSubmit", _this3).call(_this3).then(resolve, function (error) {
                _this3.setState({
                  error: error
                });

                reject(error);
              });
            }, reject);
          });
        });
        promise // `onSubmit` should never reject, so we ignore this rejection.
        .catch(noop).then(function () {
          // It can be already unmounted.
          if (_this3.mounted) // If validation fails, or `super.onSubmit` doesn't touch `submitting`, we need to reset it.
            _this3.setState(function (state) {
              return state.submitting ? {
                submitting: false
              } : null;
            });
        });
        return promise;
      }
    }, {
      key: "onValidate",
      value: function onValidate(key, value) {
        var model = this.getChildContextModel();

        if (model && key) {
          model = set(cloneDeep(model), key, cloneDeep(value));
        }

        return this.onValidateModel(model);
      }
    }, {
      key: "onValidateModel",
      value: function onValidateModel(model) {
        var _this4 = this;

        // @ts-ignore
        model = this.getModel('validate', model);
        var catched = this.props.error || null;

        try {
          this.state.validator(model);
        } catch (error) {
          catched = error;
        }

        this.setState({
          validating: true
        });
        return new Promise(function (resolve, reject) {
          _this4.props.onValidate(model, catched, function () {
            var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : catched;

            // Do not copy error from props to state.
            _this4.setState(function () {
              return {
                error: error === _this4.props.error ? null : error,
                validating: false
              };
            }, function () {
              if (error) {
                reject(error);
              } else {
                resolve();
              }
            });
          });
        });
      }
    }]);

    return _;
  }(parent);

  _.Validated = Validated;
  _.displayName = "Validated".concat(parent.displayName);
  _.defaultProps = Object.assign(Object.assign({}, parent.defaultProps), {
    onValidate: function onValidate(model, error, callback) {
      callback();
    },
    validate: 'onChangeAfterSubmit'
  });
  _.propTypes = Object.assign(Object.assign({}, parent.propTypes), {
    onValidate: PropTypes.func.isRequired,
    validator: PropTypes.any,
    validate: PropTypes.oneOf(['onChange', 'onChangeAfterSubmit', 'onSubmit']).isRequired
  });
  _.childContextTypes = Object.assign(Object.assign({}, parent.childContextTypes || {}), {
    uniforms: childContextTypes
  });
  return _;
};

function shouldRevalidate(inProps, inState) {
  return inProps === 'onChange' || inProps === 'onChangeAfterSubmit' && inState;
}

export default Validated(BaseForm);